
// Utils

export const REQUIRED_IDENTIFIER = " *";

export const LOADING_MESSAGE = "Chargement...";


// Service worker wrapper

export const NEW_VERSION_MESSAGE = "Une nouvelle version pour Le Réseau Scolaire est disponible. Installez-la !";

export const NEW_VERSION_TITLE = "Nouvelle version disponible !"

export const INSTALLING_NEW_VERSION_MESSAGE = "En cours d'installation...";


// Buttons

export const INSTALL_BUTTON_TITLE = "Installer"

export const VIDEO_YOUTUBE_REGEX = /(.*?)(^|\/|v=)([a-z0-9_-]{11})(.*)?/gim;
